import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-colum" }
const _hoisted_2 = { class: "sidebar-heading" }
const _hoisted_3 = { class: "nav-more nav-more-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/ic_more.svg" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar2 sidebar2-auto", $setup.sidebarDynamic])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/",
          class: _normalizeClass({'nav-link2': true, 'active2': $setup.path === '/'}),
          style: {"margin-top":"30px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("首页")
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menus, (value, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "flex-colum"
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(key), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: item.tag,
              key: index,
              class: _normalizeClass({'nav-link2': true, 'active2': $setup.path === item.tag})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.switchSidebar && $setup.switchSidebar(...args)))
      }, _hoisted_5)
    ])
  ], 64))
}